export enum TranslateCode {
  ONLINE_PAYMENT = 53,
  PAID = 70,
  INPAYMENT = 72,
}
